if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        // 横並びカルーセル化(section-main-product.css)のため、クリックした画像の
        // offsetLeft へスクロールする。旧来の (activeMedia.width - clientWidth) / 2 は
        // <img width="1100"> のHTML属性(全画像共通の固定値)を使っており、どの画像を開いても
        // 同じ算出結果になり実質スクロールされず常に先頭画像が表示される不具合があった。
        // また .scrollLeft への直接代入は CSS の scroll-behavior:smooth 及び
        // scroll-snap-type と競合してアニメーションが 0 に巻き戻る事象があったため、
        // behavior:'instant' を明示して確実に反映させる。
        container.scrollTo({ left: activeMedia.offsetLeft, behavior: 'instant' });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
